export { columns, LocationTable, getLocationDataFromResponse } from './columns';
